import EventRegisterForm from "features/event-registration/event-form";
import AttendeesForm from "features/event-registration/attendee-registration";
import {} from "jquery-ujs";

ReactOnRails.register({ EventRegisterForm });
ReactOnRails.register({ AttendeesForm });
